export enum ModuleNames {
    Customer = "customer",
    Voyage = "voyage",
    ERP = "erp",
}

export {};